import React, { useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import { Stack, Box, Button, Popover, Paper, Backdrop, tabsClasses } from '@mui/material';
import { Search } from '@mui/icons-material';
import FilterBarSearch from './FilterBarSearch';
import SelectType from './SelectType';
import SelectDepots from './SelectDepots';
import utils from 'components/utils';

const FilterBar = props => {
	const theme = useTheme();
	const translate = utils.useI18N();
	const tabSelected = useStoreState(state => state.wishlistSpecial.tabSelected);
	const filters = useStoreState(state => state.wishlistSpecial.filters);
	const setPage = useStoreActions(dispatch => dispatch.wishlistSpecial.setPage);
	const rowsPerPage = useStoreState(state => state.wishlistSpecial.rowsPerPage);
	const loadPending = useStoreActions(dispatch => dispatch.wishlistSpecial.loadPending);
	const loadApproved = useStoreActions(dispatch => dispatch.wishlistSpecial.loadApproved);
	const loadRefused = useStoreActions(dispatch => dispatch.wishlistSpecial.loadRefused);

	const handleSearch = event => {
		if (tabSelected === 0) {
			setPage(0);
			loadPending({ page: 0, rows: rowsPerPage, filters: filters });
		}
		if (tabSelected === 1) {
			setPage(0);
			loadApproved({ page: 0, rows: rowsPerPage, filters: filters });
		}
		if (tabSelected === 2) {
			setPage(0);
			loadRefused({ page: 0, rows: rowsPerPage, filters: filters });
		}
		if (tabSelected === 0 || tabSelected === 1 || tabSelected === 2)
			window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	};

	return (
		<Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1} variant="wrapperColor">
			<FilterBarSearch />
			<SelectType />
			<SelectDepots />
			<Button variant="dark" endIcon={<Search />} onClick={handleSearch}>
				{translate('common.search.search')}
			</Button>
		</Stack>
	);
};

export default FilterBar;
